var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 16,
    fill: "#3b6cc1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 16,
    fill: "#7c9dd6",
    transform: "rotate(45,64,64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 16,
    fill: "#adc1e5",
    transform: "rotate(90,64,64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 16,
    fill: "#d8e2f3",
    transform: "rotate(135,64,64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 16,
    fill: "#e8eef8",
    transform: "rotate(180,64,64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 16,
    fill: "#e8eef8",
    transform: "rotate(225,64,64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 16,
    fill: "#e8eef8",
    transform: "rotate(270,64,64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 16,
    fill: "#e8eef8",
    transform: "rotate(315,64,64)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64",
    calcMode: "discrete",
    dur: "1040ms",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.5621ed358d5ae8ee78dac0dfbd847f2b.svg";
export { ForwardRef as ReactComponent };